import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Video from 'components/Home/Recipes/Video';
import RecipeInfo from 'components/Home/Recipes/RecipeInfo';
import RecipeIngredients from 'components/Home/Recipes/RecipeIngredients';
import style from './style.scss';//NOSONAR

const Recipes = (props) => {
    const [open, setOpen] = useState(false);
    
    const data = props.data ? props.data : null;

    if(!data) return '';

    const getSection = (content, filter = 'section') => {
        if(!content) return [];

        return content.map((item, i) => {

            if(filter === 'section' && item.acf_fc_layout == 'section'){
                return (<RecipeIngredients key={i} item={item}/>)
            }
            if(filter === 'video' && item.acf_fc_layout == 'video'){
                return (<Video key={i} item={item}/>)
            }
            return false
        }).filter(Boolean);
    }

    const _getOpen = () => {
        setOpen(prevState => !prevState);
    }

    const itemsSection = getSection(data.content, 'section');
    const itemVideo = getSection(data.content, 'video');

    return (
        (data.active === true) && <section className="section-recipes">
            <div className="section-recipes-wrap">
                <div className="recipes-video-wrap">
                    {itemVideo}
                </div>

                <div className={"recipes-info-wrap " + (open ? ' open' : '')}>
                    <RecipeInfo data={data}/>
                    <div className="recipe-ingredients-content">
                        {itemsSection}
                    </div>
                </div>
                <button className={"recipes-info-see-more" + (open ? ' open' : '')} onClick={_getOpen}>{open ? 'Ver menos' : 'Ver más'}</button>
            </div>
        </section>
    )
}

Recipes.propTypes = {
    data: PropTypes.object,
}

export default Recipes;
